import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../../../../constants';
import { TextInput, CheckboxInput, TextArea, DateInput } from '../forms/inputs';
import { Signature } from './../../input-types';
import axios from 'axios';

axios.defaults.xsrfCookieName = 'CSRF-TOKEN';
axios.defaults.xsrfHeaderName = 'X-CSRF-Token';
axios.defaults.withCredentials = true;

export default ({ docType, docName, docId, docuuId, submissionId, currentUserId, currentUser }) => {
  const [formData, setFormData] = useState([]);
  const [formColumns, setFormColumns] = useState([]);

  useEffect(() => {
    const fetchCompanyFormsSchema = async () => {
      await axios
        .get(`${BASE_URL}/api/v1/company_documents/${docId}/doc_form_fields`)
        .then((res) => setFormColumns(res.data));
    };
    const fetchDocFormSubmissionFields = async () => {
      const url = `${BASE_URL}/api/v1/company_documents/${docId}/document_form_submissions/${submissionId}`;
      await axios.get(url).then((res) => setFormData(res.data.input_fields));
    };

    if (docType === 'CompanyForm') {
      fetchCompanyFormsSchema();
      fetchDocFormSubmissionFields();
    }
  }, []);

  return (
    <div className='container-fluid table-container'>
      {formData &&
        formData
        .sort((a, b) => a.position - b.position)
        .map((input, i) => (
          <div key={i} className='input-row-container'>
            <div className='input-label-container'>
              <span style={{ fontWeight: 'bold' }}>{input.field_name}:</span>
              <span style={{ fontSize: 12 }}>
                {input.description && input.description}
              </span>
            </div>
            <div className='input-container'>
              {input.field_type === 'text' ? (
                <TextInput
                  input={input}
                />
              ) : input.field_type === 'textarea' ? (
                <TextArea
                  input={input}
                />
              ) : input.field_type === 'date' ? (
                <DateInput
                  input={input}
                />
              ) : input.field_type === 'checkbox' ? (
                <CheckboxInput
                  input={input}
                />
              ) : input.field_type === 'signature' ? (
                <Signature
                  input={input}
                  currentUserId={currentUserId}
                  currentUser={currentUser}
                  formType={"form"}
                />
              ) : (
                <div></div>
              )}
            </div>
          </div>
        ))}
        <div className='input-row-container justify-content-end p-4'>
          <button className='btn btn-primary'>
            <a href={`/company_documents/${docuuId}/submissions/${submissionId}/edit`}>
              <span className='text-white'>Edit</span>
            </a>
          </button>
        </div>
    </div>
  );
};
